/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api; bearer: string };
type HookTuple = [response: vp.SigningAuthorityInfoResponse, fetchData: () => void, reset: () => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchSigningAuthorityInfo: ApiHook = ({ api, bearer }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [response, setResponse] = useState<vp.SigningAuthorityInfoResponse>({
    Success: false,
    ErrorMessage: '',
    AccountName: '',
    SigningAuthority: {},
  });

  const [shouldFetchData, setShouldFetchData] = useState(false);
  const source = axios.CancelToken.source();

  useEffect(() => {
    if (!shouldFetchData) return () => {};

    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const res = await api.fetchSigningAuthorityInfo(bearer, source);
      setResponse(res);
      setDataFetchingInfo(false);
      setShouldFetchData(false);
    };

    if (shouldFetchData) void loadData();

    return () => {
      source.cancel();
    };
  }, [shouldFetchData]);

  return [
    response,
    () => {
      setShouldFetchData(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        AccountName: '',
        SigningAuthority: {},
      });
      setShouldFetchData(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchSigningAuthorityInfo);
